import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	searchIcon: {
		color: theme.palette.secondary.main,
	},
}));
